import DOMPurify from 'dompurify';
// imporing react hooks
import { createContext, useContext, useEffect, useRef, useState } from 'react';
// initalizing the context
export const CartContext = createContext();

const { lang_add_to_cart, lang_added_to_cart } = window.ordering_cart_script_checkout
export const CartProvider = ({ children }) => {
    const [cartItemData, setCartItemData] = useState({})
    const [patientResources, setPatientResources] = useState([]);
    const [editResource, setEditResource] = useState({});
    const [numberOfItems, setNumberOfItems] = useState(0);
    const [isItemAddedToCart, setIsItemAddedToCart] = useState(true)
    const [isproductAdded, setIsproductAdded] = useState(false)
    const [isItemChangedInCart, setIsItemChangedInCart] = useState(false);
    const [isItemSavedInCart, setIsItemSavedInCart] = useState(false);
    const [isGlobalHeaderFooterEnabled, setIsGlobalHeaderFooterEnabled] = useState(false);
    const cartItemsRef = useRef(null);
    const fetchAllPatientResources = () => {
        const cartItems = localStorage.getItem("cartItems");
        if (cartItems) {
            const parsed = JSON.parse(cartItems);
            cartItemsRef.current = parsed;
            setPatientResources(parsed);
            setNumberOfItems(parsed.length);
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({ 'event': 'view_cart', 'ecommerce': { 'items': parsed } });
        }
    }
    // fetching all the patient resources data
    useEffect(() => {
        fetchAllPatientResources()
    }, []);

    // function to edit the item in the cart
    const editItem = (patientResource) => {
        setEditResource(JSON.parse(JSON.stringify(patientResource)));
        setIsItemAddedToCart(true);
        setIsItemChangedInCart(false);
        setIsItemSavedInCart(false);
        localStorage.setItem('selectedCartItem', JSON.stringify(patientResource));
        const fetchBtn = document.getElementById('fetchEditItemDataBtn');
        if (fetchBtn) {
            fetchBtn.click();
        } else {
            console.warn('fetchEditItemDataBtn not found in the DOM.');
        }
    }

    /**
     * Remove an item from the cart by product ID.
     * This function updates the cart items in localStorage and the state.
     */
    const remove = (productid) => {
        const cartItems = localStorage.getItem("cartItems");
        if (cartItems !== null && cartItems !== undefined) {
            let resources = JSON.parse(cartItems);
            let removedItem = {};
            resources.forEach((item) => {
                if (item.ID === productid) {
                    removedItem = item;
                }
            });
            resources = resources.filter((item) => item.ID !== productid);
            setPatientResources(resources); // set state
            setNumberOfItems(resources.length); // update count
            localStorage.setItem("cartItems", JSON.stringify(resources));
            const testBtn = document.getElementById("orderingCartAddItemTestBtn");
            const anchor = document.querySelector(`.product-card a[data-post-id="${productid}"]`);
            if (anchor) {
                anchor.classList.remove('addtocartButtonSuccess');
                anchor.classList.add('btn-smoke');
                anchor.innerHTML = DOMPurify.sanitize(lang_add_to_cart)
            }
            if (testBtn !== undefined && testBtn !== null) {
                testBtn.click();
            }
            updateHeaderCartBtn()
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                event: "remove_from_cart",
                ecommerce: {
                    items: [
                        {
                            item_name: removedItem.post_title,
                            item_id: removedItem.material_code,
                            item_size: removedItem.order_size,
                            item_variant: removedItem.order_variant,
                            quantity: removedItem.order_quantity,
                        },
                    ],
                },
            });
        }
    }

    /**
     * Navigate to the checkout page with the items in the cart.
     * This function collects the items from localStorage, sanitizes the URL,
     */
    const gotToCheckoutByOrderNow = () => {
        let orderedItems = JSON.parse('[]');
        let localItemData = localStorage.getItem('cartItems');
        if (localItemData !== null && localItemData !== undefined) {
            let cartItems = JSON.parse(localItemData);
            cartItems.forEach(item => {
                let orderItem = {
                    "item_name": item.post_title,
                    "item_id": item.material_code,
                    "item_size": item.order_size,
                    "item_variant": item.order_variant,
                    "quantity": item.order_quantity
                };
                orderedItems.push(orderItem);
            });
        }
        window.dataLayer = window.dataLayer || []; window.dataLayer.push({ 'event': 'begin_checkout', 'ecommerce': { 'items': orderedItems } });
        setTimeout(function () {
            const sanitizedUrl = new URL(DOMPurify.sanitize(site_url_obj.siteurl + "/checkout"), window.location.origin).href;
            window.location.href = sanitizedUrl;
        }, 500);
    }

    // function to handle changes in the edit item
    const editItemOnChange = (patientResource) => {
        setIsItemAddedToCart(false);
        setIsItemChangedInCart(true);
        setIsItemSavedInCart(false);
    }

    /**
     * Check if the limit quantity flag is set and handle edit item save.
     * This function checks the total quantity of items in the cart,
     * compares it with the limit, and either shows a modal or saves the item.
     */
    const isLimitQuantityFlagEditItemSave = (editResource, langCartLimit, orderPage = false) => {
        const cartItems = localStorage.getItem("cartItems");
        if (cartItems !== null && cartItems !== undefined) {
            let resources = JSON.parse(cartItems);
            const currentorderquantity = Number(editResource.order_quantity);
            let pastquantity = 0;
            let totalquantity = 0;
            resources.forEach((resource) => {
                if (resource.ID !== editResource.ID) {
                    pastquantity = Number(resource.order_quantity);
                    totalquantity += pastquantity;
                }
            });
            totalquantity += currentorderquantity;
            if (langCartLimit < totalquantity) {
                // Show modal
                const limitModal = document.getElementById("quantityLimitPopupCart");
                const modalLimit = new bootstrap.Modal(limitModal);
                modalLimit.show();
                setTimeout(() => {
                    const closeBtn = document.getElementById(
                        "closeButtonreachlimiteditItemBackToCart",
                    );
                    if (closeBtn) closeBtn.click();
                }, 2000);
            } else {
                // Proceed with saving the updated item
                resources = JSON.parse(cartItems);
                const index = resources.findIndex(
                    (item) => item.ID === editResource.ID,
                );
                if (index !== -1) {
                    resources[index] = editResource;
                }
                setPatientResources(resources);
                setNumberOfItems(resources.length);
                localStorage.setItem("cartItems", JSON.stringify(resources));
                setIsItemAddedToCart(false);
                setIsItemChangedInCart(false);
                setIsItemSavedInCart(true);
                if (orderPage) {
                    setTimeout(() => {
                        const editBtn = document.getElementById("editItemBacktoCheckoutBtn");
                        if (editBtn) editBtn.click();

                        const testBtn = document.getElementById("orderingCartAddItemTestBtn");
                        if (testBtn) testBtn.click();
                    }, 1000);
                } else {
                    setTimeout(() => {
                        const editBtn = document.getElementById("editItemBacktoCheckoutBtn");
                        if (editBtn) editBtn.click();

                        const testBtn = document.getElementById("orderingCartAddItemTestBtn");
                        if (testBtn) testBtn.click();
                    }, 1000);
                }
            }
        }
    }

    /**
     * Save changes made to the edit item.
     * This function updates the cart items in localStorage,
     * updates the state, and hides the edit drawer.
     */
    const editItemSaveChanges = (editResource, orderPage = false) => {
        const cartItems = localStorage.getItem("cartItems");
        if (cartItems !== null && cartItems !== undefined) {
            let resources = JSON.parse(cartItems);
            const index = resources.findIndex(
                (item) => item.ID === editResource.ID,
            );
            if (index !== -1) {
                resources[index] = editResource;
            }
            setEditResource(resources);
            setNumberOfItems(resources.length);
            localStorage.setItem("cartItems", JSON.stringify(resources));
            setIsItemAddedToCart(false);
            setIsItemChangedInCart(false);
            setIsItemSavedInCart(true);
            if (orderPage) {
                const editDrawerComp = bootstrap.Offcanvas.getOrCreateInstance(document.getElementById('orderingCartEditItemDivReact'));
                editDrawerComp.hide();
            } else {
                const editDrawerComp = bootstrap.Offcanvas.getOrCreateInstance(document.getElementById('orderingCartEditItemDivReact'));
                const infoDrawerComp = bootstrap.Offcanvas.getOrCreateInstance(document.getElementById('organonOrderingCartOffcanvasReact'));
                if (editDrawerComp) {
                    setTimeout(() => {
                        editDrawerComp.hide();
                        document.getElementById('orderingCartEditItemDivReact').addEventListener('hidden.bs.offcanvas', () => {
                            infoDrawerComp.show();
                        });
                    }, 1000)
                }
            }
        }
    }

    /**
     * Event listener to handle clicks on the "add to cart" button.
     * This function retrieves the selected cart item from localStorage,
     */
    useEffect(() => {
        const handleClick = (event) => {
            const target = event.target;
            if (target.matches('.addtocart')) {
                const selectedItem = JSON.parse(localStorage.getItem('selectedCartItem'))
                setCartItemData(selectedItem)
                const offcanvasElement = document.getElementById('cartFormffReact');
                if (offcanvasElement) {
                    const bsOffcanvas = bootstrap.Offcanvas.getInstance(offcanvasElement);
                    bsOffcanvas.show();
                }
            }
        };

        document.addEventListener('click', handleClick);
        return () => {
            document.removeEventListener('click', handleClick);
        };
    }, []);


    /**
     * Handle the "order now" action from the organization cart.
     */
    const orderNowOrgCart = (productData) => {
        if (productData === "") {
            return false;
        }
        setIsproductAdded(false)
        setCartItemData(productData)
    }

    /**
     * Update the header cart button with the current number of items.
     * This function checks the localStorage for cart items,
     * updates the button text, and manages visibility of mobile and desktop cart elements.
     */
    const updateHeaderCartBtn = () => {
        const btn = document.getElementById('orderingCartBtnReact');
        const btnMobile = document.getElementById('orderingCartBtnMobile');
        const deskstopCart = document.getElementById('deskstopCart');
        const blueDotMobile = document.getElementById('blueDot');
        const globalCounter = document.getElementById('og-order-cart-item-counter');
        const globalHeaderEnabled = globalCounter !== null && globalCounter !== undefined;
        setIsGlobalHeaderFooterEnabled(globalHeaderEnabled);
        let localStorageItemCount = 0;
        const cartItems = localStorage.getItem('cartItems');
        if (cartItems) {
            try {
                localStorageItemCount = JSON.parse(cartItems).length;
            } catch (e) {
                console.error('Error parsing cartItems from localStorage', e);
            }
        }
        if (btn) {
            if (globalHeaderEnabled) {
                if (globalCounter) {
                    globalCounter.textContent = encodeURIComponent(localStorageItemCount);
                }
            } else {
                const buttonTitle = btn.innerHTML;
                const cartItemsStr = buttonTitle.substring(buttonTitle.indexOf('('), buttonTitle.indexOf(')') + 1);
                btn.innerHTML = DOMPurify.sanitize(buttonTitle.replace(cartItemsStr, `(${encodeURIComponent(localStorageItemCount)})`),{ALLOWED_TAGS:['ion-icon','svg']});
            }
        }
        if (btnMobile && deskstopCart && blueDotMobile) {
            btnMobile.style.visibility = localStorageItemCount > 0 ? 'visible' : 'hidden';
            deskstopCart.style.display = localStorageItemCount > 0 ? 'block' : 'none';
            blueDotMobile.classList.toggle('blueDot', localStorageItemCount > 0);
        }
        const refreshBtn = document.getElementById("orderingSummaryRefreshBtn");
        if (refreshBtn) {
            refreshBtn.click();
        }
    }

    /**
     * Add an item to the cart with limit check.
     * This function checks if the selected product data is valid,
     * calculates the total quantity of items in the cart,
     * and adds the item to the cart if it does not exceed the limit.
     */
    const addtoMulticartlimitflag = (selectedProductData, isCartLimitActive = false, cartLimit, checkoutflag = false) => {
        if (selectedProductData === "") {
            return false;
        }
        let localStorageCartItems = JSON.parse(localStorage.getItem('cartItems'));
        if (localStorageCartItems == null && localStorageCartItems == undefined) {
            localStorage.setItem('cartItems', '[]');
            localStorageCartItems = []
        }
        let currentorderquantity = selectedProductData.order_quantity;
        let pastquantity = 0;
        let totalquantity = 0;

        localStorageCartItems.forEach(resourcesvalues => {
            pastquantity = resourcesvalues.order_quantity;
            totalquantity = totalquantity * 1 + pastquantity * 1;
        });
        totalquantity = totalquantity * 1 + currentorderquantity * 1;
        if (isCartLimitActive && parseFloat(cartLimit) < totalquantity) {
            // Show modal
            const limitModal = document.getElementById("quantityLimitPopupCart");
            const modalLimit = new bootstrap.Modal(limitModal);
            modalLimit.show();
            setTimeout(() => {
                const closeBtn = document.getElementById("closeButtonCartSetting");
                if (closeBtn) closeBtn.click();
            }, 2000);
        } else {
            const anchor = document.querySelector(`.product-card a[data-post-id="${selectedProductData.ID}"]`);
            if (anchor) {
                anchor.classList.remove('btn-smoke');
                anchor.classList.add('addtocartButtonSuccess');
                anchor.innerHTML = DOMPurify.sanitize(lang_added_to_cart)
            }
            let localStorageCartItems = JSON.parse(localStorage.getItem('cartItems'));
            if (localStorageCartItems == null && localStorageCartItems == undefined) {
                localStorage.setItem('cartItems', '[]');
                localStorageCartItems = JSON.parse(localStorage.getItem('cartItems'));
                localStorageCartItems.push(selectedProductData);
                localStorage.setItem('cartItems', JSON.stringify(localStorageCartItems));
            } else {
                localStorageCartItems = JSON.parse(localStorage.getItem('cartItems'));
                localStorageCartItems.push(selectedProductData);
                localStorage.setItem('cartItems', JSON.stringify(localStorageCartItems));
            }
            setIsproductAdded(true)
            setTimeout(() => {
                const offcanvasElement = document.getElementById('cartFormffReact');
                if (offcanvasElement) {
                    const bsOffcanvas = bootstrap.Offcanvas.getInstance(offcanvasElement);

                    if (bsOffcanvas) {
                        bsOffcanvas.hide();
                    }
                }
            }, 1500)
            updateHeaderCartBtn()
        }
        if (checkoutflag === true) {
            setTimeout(() => {
                const sanitizedUrl = new URL(DOMPurify.sanitize(site_url_obj.siteurl + "/checkout"), window.location.origin).href;
                window.location.href = sanitizedUrl;
            }, 500);
        }
    };

    /**
     * Adding event listener to fetch data when the offcanvas is opened.
     * This function fetches all patient resources when the offcanvas is shown.
     */
    useEffect(() => {
        const offcanvasElement = document.getElementById('organonOrderingCartOffcanvasReact');
        const handleDrawerOpen = () => {
            fetchAllPatientResources()
        };
        if (offcanvasElement) {
            offcanvasElement.addEventListener('shown.bs.offcanvas', handleDrawerOpen);
        }
        return () => {
            if (offcanvasElement) {
                offcanvasElement.removeEventListener('shown.bs.offcanvas', handleDrawerOpen);
            }
        };
    }, []);

    /**
     * Adding event listener to fetch data when the edit item offcanvas is closed.
     * This function fetches all patient resources when the edit item offcanvas is hidden.
     */
    useEffect(() => {
        const offcanvasElement = document.getElementById('orderingCartEditItemDivReact');
        const handleDrawerOpen = () => {
            fetchAllPatientResources()
        };
        if (offcanvasElement) {
            offcanvasElement.addEventListener('hide.bs.offcanvas', handleDrawerOpen);
        }
        return () => {
            if (offcanvasElement) {
                offcanvasElement.removeEventListener('hide.bs.offcanvas', handleDrawerOpen);
            }
        };
    }, [])


    /**
     * Event listener to clear the selected cart item when the offcanvas is hidden.
     * This function removes the selected cart item from localStorage
     */
    useEffect(() => {
        const offcanvasEl = document.getElementById('cartFormffReact');
        const handleHidden = () => {
            localStorage.removeItem('selectedCartItem')
        };
        offcanvasEl?.addEventListener('hidden.bs.offcanvas', handleHidden);
        return () => {
            offcanvasEl?.removeEventListener('hidden.bs.offcanvas', handleHidden);
        };
    }, []);

    /**
     * Effect to update the header cart button when the component mounts.
     * This function calls updateHeaderCartBtn to set the initial state of the cart button.
     */
    useEffect(() => {
        updateHeaderCartBtn()
    }, [])

    return (
        <CartContext.Provider value={{ editItem, remove, gotToCheckoutByOrderNow, editItemOnChange, isLimitQuantityFlagEditItemSave, editItemSaveChanges, patientResources, setPatientResources, editResource, setEditResource, numberOfItems, setNumberOfItems, isItemAddedToCart, setIsItemAddedToCart, isItemChangedInCart, setIsItemChangedInCart, isItemSavedInCart, setIsItemSavedInCart, cartItemData, isproductAdded, setIsproductAdded, orderNowOrgCart, addtoMulticartlimitflag, updateHeaderCartBtn }}>
            {children}
        </CartContext.Provider>
    );
};
export const useCart = () => useContext(CartContext)